import React, { useEffect, useRef, useState } from 'react';
import '../../../../css/common/chat/ChatHeaderOverflowMenu.css';

// チャットヘッダー右上の ︙ メニュー。items=[{key,icon,label,onClick,hidden?}] を渡すだけ。
// personal / group チャットで「リンク」「写真・ファイル」導線に利用する。
export default function ChatHeaderOverflowMenu({ items = [], ariaLabel = 'メニュー' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const visible = (items || []).filter((item) => item && !item.hidden);

  useEffect(() => {
    if (!open) return undefined;
    const onDocMouseDown = (event) => {
      if (ref.current && !ref.current.contains(event.target)) setOpen(false);
    };
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDocMouseDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onDocMouseDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  if (!visible.length) return null;

  return (
    <div className="chat-header-overflow" ref={ref}>
      <button
        type="button"
        className="chat-header-icon-button chat-header-overflow__trigger"
        onClick={() => setOpen((v) => !v)}
        aria-label={ariaLabel}
        title={ariaLabel}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <i className="fa-solid fa-ellipsis-vertical" aria-hidden="true" />
      </button>
      {open ? (
        <div className="chat-header-overflow__menu" role="menu">
          {visible.map((item) => (
            <button
              key={item.key}
              type="button"
              role="menuitem"
              className="chat-header-overflow__item"
              onClick={() => {
                setOpen(false);
                item.onClick?.();
              }}
            >
              <i className={`fa-solid ${item.icon}`} aria-hidden="true" />
              <span>{item.label}</span>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
